var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.218 17.6895C13.218 17.9065 13.118 18.0065 12.868 18.0065H11.116C10.883 18.0065 10.782 17.9065 10.782 17.6895V15.9545C10.782 15.7375 10.883 15.6365 11.116 15.6365H12.868C13.118 15.6365 13.218 15.7375 13.218 15.9545V17.6895ZM11.199 5.99349H12.801C13.034 5.99349 13.118 6.09349 13.118 6.29349L12.885 13.8355C12.885 14.0015 12.819 14.0515 12.635 14.0515H11.4C11.216 14.0515 11.15 14.0015 11.15 13.8355L10.883 6.29349C10.883 6.09349 10.966 5.99349 11.199 5.99349ZM12 2.00049C6.487 2.00049 2 6.48549 2 12.0005C2 17.5135 6.487 22.0005 12 22.0005C17.514 22.0005 22 17.5135 22 12.0005C22 6.48549 17.514 2.00049 12 2.00049Z",
    fill: "#CE2323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.7ac9812df370bd539d6cc9ef20ba6b33.svg";
export { ForwardRef as ReactComponent };